export const sessionHeadersData = [
  {
    text: 'Name',
    value: 'name',
    sortable: true,
  },
  {
    text: 'Session Date',
    value: 'date',
    sortable: true,
  },
  {
    text: 'Warm Up',
    value: 'warmup',
    sortable: false,
  },
  {
    text: 'Questions',
    value: 'practices',
    sortable: false,
  },
  {
    text: 'Homework',
    value: 'homework',
    sortable: false,
  },
  {
    text: 'Badge',
    value: 'badge',
    sortable: false,
  },
  {
    text: 'Created',
    value: 'created',
    sortable: true,
  },
];
